/**
 * account-fe permission namespace + constants (AUTHZ.md §5.4).
 *
 * Mirror of apps/account-api/src/permissions.js so FE check-sites reference
 * `PERMS.CREATE_ORG` rather than a raw string. The #275 aggregator consolidates
 * these into account-common so the FE and API share one source of truth; until
 * then this minimal module keeps the foundation usable.
 */

export const APP_NAMESPACE = "account";

export const PERMS = Object.freeze({
  CREATE_ORG: "create_org",
});
